// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"056b5c32","47":"dfe1b5c3","197":"6172bf87","245":"e66f2484","300":"230c902a","363":"12fcff8b","374":"aafcd36f","436":"6314f89e","486":"9530f2f5","542":"8ecfd2a2","681":"aaf84c7e","714":"480b53ab","841":"01fd0c6d","911":"fe968bf5"}[chunkId] + ".chunk.js";
};